<template>
  <div id="OrderSlide" class="MainSlide carousel slide" ref="slide">
    <div class="row toprow">
      <span>Reorder Previous Order</span>
      <ol class="carousel-indicators">
        <li
          v-for="(order, index) in orders.slice().reverse()"
          :key="index"
          data-target="#OrderSlide"
          :data-slide-to="index"
          :class="index == 0 ? 'active' : ''"
        ></li>
      </ol>
    </div>
    <div class="carousel-inner">
      <div
        v-for="(order, index) in orders.slice().reverse()"
        :key="'a' + index"
        :class="index == 0 ? 'carousel-item active' : 'carousel-item'"
      >
        <div class="DetailSection">
          <div class="left">
            <p
              v-for="(item, indexx) in GetSliceOrder(order.OrderItems)"
              :key="indexx"
            >
              {{ item.Quantity }}x {{ item.Name }}
            </p>
          </div>
          <div class="right">
            <a
              class="btn ReorderBtn"
              :style="mobileStyles.btn"
              @click="ReorderConfirm(order)"
              >{{ $t("message.reorder") }}</a
            >
          </div>
        </div>
        <div class="ButtomLine">
          <p>
            {{
              GetOrderNumber(order.OrderItems) > 0
                ? "Plus " + GetOrderNumber(order.OrderItems) + " items -"
                : ""
            }}
            {{ GetDate(order.CreatedOn) }}
          </p>
        </div>
      </div>
    </div>

    <p class="SkipBtn" @click="SkipPressed()">{{ $t("message.skip") }}</p>
    <confirm
      v-if="ShowConfirm"
      ref="reorderConfirm"
      :confirm-title="$t('message.reorder')"
      :proccessing="Progressing"
      @confirmed="Reorder"
      @close="CloseConfirm"
    >
      <template slot="body">
        <p class="mx-3">{{ $t("message.reorderCurrentOrder") }} ?</p>
      </template>
    </confirm>
  </div>
</template>
<script>
import { $$ } from "../../sharedscripts/OO_jquery";
import { mapGetters } from "vuex";
import confirm from "../confirm";
import { getStore } from "../../api/services/storeService.js";
import {
  IsStoreOpenAtTime,
  getCurrentDate,
} from "./../../api/helpers/datetimeHelper.js";
import { DateTime } from "luxon";
export default {
  data() {
    return {
      ShowConfirm: false,
      SelectedOrder: null,
      Progressing: false,
    };
  },
  components: {
    confirm,
  },
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(["mobileStyles"]),
  },
  mounted() {
    this.LoadCarousel();
  },
  methods: {
    LoadCarousel() {
      $$(".MainSlide").carousel({
        interval: false,
        wrap: false,
      });
      $$(".MainSlide").on("touchstart", function (event) {
        var xClick = event.originalEvent.touches[0].pageX;
        $$(this).one("touchmove", function (event) {
          var xMove = event.originalEvent.touches[0].pageX;
          if (Math.floor(xClick - xMove) > 5) {
            $$(this).carousel("next");
          } else if (Math.floor(xClick - xMove) < -5) {
            $$(this).carousel("prev");
          }
        });
        $$(".carousel").on("touchend", function () {
          $$(this).off("touchmove");
        });
      });
    },
    GetOrderNumber(order) {
      if (order) return order.length > 4 ? order.length - 4 : 0;
    },
    GetSliceOrder(items) {
      if (items) return items.length > 4 ? items.slice(0, 4) : items;
    },
    ReorderConfirm(order) {
      this.SelectedOrder = order;
      this.ShowConfirm = true;
    },
    CloseConfirm() {
      this.ShowConfirm = false;
    },
    async Reorder() {
      this.Progressing = true;
      let store = null;
      if (this.SelectedOrder.StoreID !== this.$route.params.storeid) {
        store = await getStore(this.SelectedOrder.StoreID).get();
        if (store.exists) {
          store = store.data();
          var now = getCurrentDate(store.TimezoneIanaFormat);
          var closed =
            (!IsStoreOpenAtTime(
              store.BlackoutDates,
              store.OperatingHours,
              store.IsInOperation,
              now
            ) &&
              !(
                store.EnablePreoderForDelivery || store.EnablePreoderForPickup
              )) ||
            !store.IsInOperation;
          if (closed) {
            this.Progressing = false;
            alert(
              store.ClosingStoreMessage
                ? store.ClosingStoreMessage
                : this.$t("message.CurrentlyNotTakingOnlineOrders")
            );
            return false;
          }
        } else {
          this.Progressing = false;
          alert(this.$t("StoreNotFound"));
          return false;
        }
      } else if (this.IsStoreClose) {
        this.Progressing = false;
        alert(
          this.currentStoreDoc.ClosingStoreMessage
            ? this.currentStoreDoc.ClosingStoreMessage
            : this.$t("message.CurrentlyNotTakingOnlineOrders")
        );
        return false;
      }
      this.Progressing = false;
      this.$router.push({
        name: "shoppingcartmobile",
        params: {
          storeid: store == null ? this.$route.params.storeid : store.ID,
          storename: store == null ? this.$route.params.storename : store.Name,
          orderid: this.SelectedOrder.UDID,
        },
      });
      this.$refs.reorderConfirm.hideModal();
    },
    SkipPressed() {
      this.$emit("SkipPressed");
    },
    GetDate(date) {
      return DateTime.fromHTTP(date).toFormat("ccc dd LLL hh:mm a");
    },
  },
};
</script>


<style  lang="scss" scoped>
.MainSlide {
  height: 166px;
  width: 100%;
  .toprow {
    margin: 10px 0;
    height: 25px;
    span {
      color: #343434;
      font-family: "Source Sans Pro";
      font-weight: bold;
      font-size: 20px;
    }
    .carousel-indicators {
      justify-content: flex-end;
      margin: 0;
      top: 10px;
      bottom: auto;
      left: auto;
      li {
        border-radius: 12px;
        width: 6px;
        height: 6px;
        background-color: #6f6f6f;
        opacity: 50%;
      }
      .active {
        opacity: 100%;
      }
    }
  }
  .carousel-inner {
    height: 121px;
    margin: 0;

    .carousel-item {
      height: 100%;
    }
    .DetailSection {
      height: 104px;

      .left {
        width: 60%;
        float: left;
        height: 100%;
        p {
          font-family: "Source Sans Pro";
          font-size: 10px;
          color: #343434;
          margin-bottom: 0;
        }
      }
      .right {
        width: 40%;
        float: right;
        height: 100%;
        position: relative;
        .ReorderBtn {
          border-radius: 2px;
          padding: 10px 15px;
          font-size: 15px;
          font-family: Open sans;
          margin: 0;
          position: absolute;
          right: 0;
          bottom: 9px;
        }
      }
    }
  }
  .ButtomLine {
    position: absolute;
    margin: 3px 0 0 0;
    bottom: 0;
    p {
      margin: 0;
      font-family: "Open Sans";
      font-size: 10px;
      color: #6f6f6f;
    }
  }
  .SkipBtn {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 12px;
    font-family: "Open Sans";
    color: #1f1f1f;
    margin: 0 0 10px 0;
  }
}
</style>